import { lazy } from "react";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";

const ConferencePage = lazy(() => import("./ConferencePage"));

export type ConferencePagesNavigationParams = {
  conferenceConference: PageNavParams<{ channelId: string }>;
};

export const conferencePagesNavigationConfig: ModulePagesConfig<ConferencePagesNavigationParams> =
  {
    conferenceConference: {
      element: <ConferencePage />,
      path: "conference/:channelId",
      isPrivate: true,
    },
  };
